module.exports = __webpack_public_path__ + "img/file-csv.d6369a99.svg";